import React from "react";
import { Helmet } from "react-helmet-async";
import Navbar from "../Components/Navbar/Navbar";
import ProductCard from "../Components/ProductCard/ProductCard";
import Footer from "../Components/Footer/Footer";
import { Box } from "@mui/material";
import CardImg from "../Assets/vegan_chicken_croissant.png";
import useMetaTracking from "../hooks/useMetaTracking";

function VeganChickenCroissant() {
  useMetaTracking("ViewContent", {
    content_name: "Vegan Chicken Croissant",
    content_category: "Vegan Menu",
    content_ids: ["vegan_chicken_croissant"],
    content_type: "vegan_pastries",
    value: 4.75,
    currency: "USD",
  });

  const pageTitle = "Vegan Chicken Croissant | Đông Hưng Viên Bakery";
  const pageDescription =
    "Golden, layered croissant dough wrapped around seasoned vegan chicken and vegan cheese, baked until crisp on the outside and warm inside. A refined take on a savory classic.";

  return (
    <>
      <Helmet>
        <title>{pageTitle}</title>
        <meta name="description" content={pageDescription} />
        <meta property="og:title" content={pageTitle} />
        <meta property="og:description" content={pageDescription} />
        <meta property="og:image" content={CardImg} />
      </Helmet>

      <Box className="product-page" sx={{ pt: 10, background: "#0f0f0f", color: "#fff" }}>
        <Navbar />
        <ProductCard
          cardImg={CardImg}
          titleHead="Vegan Chicken Croissant"
          titleSubHead="$4.75 each"
          detailBody="Golden, layered croissant dough wrapped around seasoned vegan chicken and cheese, baked until crisp on the outside and warm inside. A refined take on a savory classic."
          detailBodyBr="Contains: wheat, soy, sesame"
          detailBody3="Vegan"
          ProductCardBtn="View Full Vegan Menu"
          btnLink="/vegan-menu"
        />
        <Footer />
      </Box>
    </>
  );
}

export default VeganChickenCroissant;